module.exports = __webpack_public_path__ + "img/banner.4f5996e0.png";